import React, { useEffect } from "react";
import Spinner from "../common/Spinner";
import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  ColumnChooser,
  Summary,
  TotalItem,
  Selection,
  Export,
} from "devextreme-react/data-grid";
import { locale } from "devextreme/localization";
import { getNavigatorLanguage } from "../../utils/index";

const SalesReport = ({ reportsStore, isLoading }) => {
  useEffect(() => {
    locale(getNavigatorLanguage());
  }, []);

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });
  };

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      {reportsStore && !isLoading && (
        <div className="mt-3">
          <h5>Sales Reports</h5>
          <DataGrid
            id="gridContainer"
            dataSource={reportsStore}
            showBorders={true}
            hoverStateEnabled={true}
            cellHintEnabled={true}
            remoteOperations={false}
            showRowLines={true}
            showColumnLines={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
            rowAlternationEnabled={true}
            wordWrapEnabled={true}
            onToolbarPreparing={onToolbarPreparing}
            columnResizingMode="widget"
            columnMinWidth={50}
            columnAutoWidth={true}
          >
            <Selection
              mode="multiple"
              selectAllMode="page"
              showCheckBoxesMode="always"
            />

            <Export
              enabled={true}
              excelWrapTextEnabled={true}
              fileName="Sales reports"
              allowExportSelectedData={true}
            />
            <HeaderFilter visible={true} />
            <FilterRow visible={true} applyFilter="auto" />
            <ColumnChooser enabled={true} mode="select" />
            <SearchPanel visible={true} width={300} />
            <Paging defaultPageSize={50} />
            <Pager
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={[50, 100, 200]}
              showInfo={true}
            />

            <Column dataField="productCode" caption="Product Code" />
            <Column dataField="productName" caption="Product Name" />
            <Column dataField="productUPC" caption="UPC" />
            <Column dataField="purchaseDocumentDate" caption="Document Date" />
            <Column
              dataField="salesDocumentNumber"
              caption="Sales Document Number"
            />

            <Column caption="Sales Package">
              <Column dataField="salesPackageCardboard" caption="Cardboard" />
              <Column
                dataField="salesPackageClearBrownGlass"
                caption="Clear / Brown Glass"
              />
              <Column
                dataField="salesPackageGreenOtherGlass"
                caption="Green / Other Glass"
              />
              <Column dataField="salesPackageMetalAl" caption="Metal Al" />
              <Column dataField="salesPackageMetalFe" caption="Metal Fe" />
              <Column
                dataField="salesPackageOtherMetal"
                caption="Other Metal"
              />
              <Column
                dataField="salesPackagePlasticPet"
                caption="Plastic PET"
              />
              <Column
                dataField="salesPackagePlasticPpPe"
                caption="Plastic PP, PE"
              />
              <Column dataField="salesPackageWood" caption="Wood" />
            </Column>

            <Column caption="Group Package">
              <Column dataField="groupPackageMetal" caption="Metal" />
              <Column dataField="groupPackagePaper" caption="Paper" />
              <Column dataField="groupPackagePlastic" caption="Plastic" />
              <Column dataField="groupPackageWood" caption="Wood" />
            </Column>

            <Column caption="Transport Package">
              <Column
                dataField="transportPackageCardboard"
                caption="Cardboard"
              />
              <Column dataField="transportPackagePlastic" caption="Plastic" />
              <Column dataField="transportPackageWood" caption="Wood" />
            </Column>
            <Column dataField="quantity" caption="Quantity" />
            <Column dataField="totalNetWeight" caption="Net Weight" />
            <Column dataField="totalGrossWeight" caption="Gross Weight" />
            <Summary recalculateWhileEditing={true} texts={{ sum: "{0}" }}>
              <TotalItem column="quantity" summaryType="sum" />
              <TotalItem column="totalNetWeight" summaryType="sum" />
              <TotalItem column="totalGrossWeight" summaryType="sum" />
              <TotalItem column="salesPackageCardboard" summaryType="sum" />
              <TotalItem
                column="salesPackageClearBrownGlass"
                summaryType="sum"
              />
              <TotalItem
                column="salesPackageGreenOtherGlass"
                summaryType="sum"
              />
              <TotalItem column="salesPackageMetalAl" summaryType="sum" />
              <TotalItem column="salesPackageMetalFe" summaryType="sum" />
              <TotalItem column="salesPackageOtherMetal" summaryType="sum" />
              <TotalItem column="salesPackagePlasticPet" summaryType="sum" />
              <TotalItem column="salesPackagePlasticPpPe" summaryType="sum" />
              <TotalItem column="salesPackageWood" summaryType="sum" />
              <TotalItem column="groupPackageMetal" summaryType="sum" />
              <TotalItem column="groupPackagePaper" summaryType="sum" />
              <TotalItem column="groupPackagePlastic" summaryType="sum" />
              <TotalItem column="groupPackageWood" summaryType="sum" />
              <TotalItem column="transportPackageCardboard" summaryType="sum" />
              <TotalItem column="transportPackagePlastic" summaryType="sum" />
              <TotalItem column="transportPackageWood" summaryType="sum" />
            </Summary>
          </DataGrid>
        </div>
      )}
      {isLoading && <Spinner />}
    </div>
  );
};

export default SalesReport;
